import React, { useEffect, useRef } from 'react';

const HdfcRedirector = ({ htmlString }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!htmlString || !containerRef.current) return;

        try {
            // Create a true isolated DOM element inside our ref container
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            
            // Extract the structural form layout sent by HDFC
            const form = tempDiv.querySelector('form');

            if (form) {
                // Append it directly to the active webpage document window body
                document.body.appendChild(form);
                // Execute the native programmatic post submission
                form.submit();
            } else {
                console.error("No hidden form found within the provided gateway payload string.");
            }
        } catch (error) {
            console.error("HDFC Redirect structural execution failure:", error);
        }
    }, [htmlString]);

    return (
        <div 
            style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                width: '100vw', 
                height: '100vh', 
                backgroundColor: '#ffffff', 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                zIndex: 99999 
            }}
        >
            <div className="text-center">
                <div className="spinner-border text-primary mb-3" role="status"></div>
                <h4 className="fw-bold text-secondary">Connecting to HDFC Bank...</h4>
                <p className="text-muted small">Setting up secure e-mandate channel. Please wait...</p>
            </div>
            
            {/* Hidden hook anchor node where our effect hooks into */}
            <div ref={containerRef} style={{ display: 'none' }} />
        </div>
    );
};

export default HdfcRedirector;